import type { DealTypeMatchStatus } from "@/lib/opsDealTypes/dealTypeMatch";

export function OpsDealTypeMatchBadge(props: {
  status?: DealTypeMatchStatus | string | null;
  productName?: string | null;
  saleName?: string | null;
}) {
  const status = props.status === "matched" || props.status === "product_only" || props.status === "unresolved"
    ? props.status
    : "unresolved";
  if (status === "matched") {
    return (
      <span className="inline-flex items-center gap-1 text-emerald-700 dark:text-emerald-300" title={[props.productName, props.saleName].filter(Boolean).join(" · ") || "Deal type matched"}>
        <svg viewBox="0 0 20 20" className="h-4 w-4" aria-hidden="true">
          <circle cx="10" cy="10" r="9" fill="currentColor" className="text-emerald-600 dark:text-emerald-400" />
          <path d="M6.2 10.4 8.6 12.8 13.8 7.4" fill="none" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        <span className="sr-only">Deal type matched</span>
      </span>
    );
  }
  if (status === "product_only") {
    return (
      <span
        className="inline-flex h-4 w-4 items-center justify-center rounded-full border-2 border-amber-500 text-[9px] font-bold text-amber-700 dark:text-amber-300"
        title={props.productName ? `${props.productName} — sale type still needed` : "Product type matched; sale type still needed"}
      >
        P
      </span>
    );
  }
  return (
    <span
      className="inline-flex h-4 w-4 items-center justify-center rounded-full border-2 border-gray-400 text-[9px] font-bold text-gray-500 dark:border-zinc-500 dark:text-zinc-400"
      title="Deal type not matched"
    >
      ?
    </span>
  );
}
